import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { GetEnumValues } from "motw_core/Utils/EnumUtils";
import * as React from "react";
import { EPanelId } from "../services/Shared/EPanelId";
import { ESharedComponent } from "../services/UI/State/ESharedComponent";
import { State } from "../services/UI/State/State";
import { IActivePanelState } from "./Shared/ActivePanel/IActivePanelState";

export function ScrollPositionTracker() {
    React.useEffect(() => {
        GetEnumValues(EPanelId).map((panelId) => {
            scrollPositions.set(panelId, 0);
        });
    }, []);

    useScrollPosition(
        ({ prevPos, currPos }) => {
            const activePanelId = State.ReadClass<IActivePanelState>(
                ESharedComponent.ActivePanel
            ).state.activePanelId;

            if (!activePanelId) {
                return;
            }

            scrollPositions.set(activePanelId, currPos.y);
        },
        undefined,
        undefined,
        true,
        400
    );

    return <span />;
}

export const scrollPositions = new Map<EPanelId, number>();
